import styled from 'styled-components';

export const StyledArchivePage = styled.div`
    .report {
        margin-top: 38px;

        .report-top {
            margin-bottom: 28px;

            .plus {
                width: 16px;
                height: 16px;
                margin-inline-start: 10px;
            }

            .hidden-switch {
                flex: 1 1 1px;
                padding: 0 24px;
            }
        }
    }

    .main-wrapper {
        padding: 24px;  

        .ScrollbarsCustom-Scroller {
            padding-right: 5px;
        }

        .ScrollbarsCustom-Content {
            direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'}
        }
        
        .table-header {
          display: grid;
          grid-template-columns: 5fr 32px 64px;
          margin-bottom: 12px;
          .titles {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            text-align: center;
            color: rgba(55, 54, 71, 0.7);
            margin: 0 32px 0 32px;
          }
        }

        .cards-wrapper {
            display: flex;
            flex-direction: column;
            gap: 14px;
            .download-link {
              /* hide download link, it will be clicked programmatically */
              visibility: collapse;
              position: absolute;
              width: 0;
              height: 0;
            }
        }
    }
`
